/*
 * Opening the till code from elsewhere (Saif, 21 Oct 2026): "Show my code" on a live order opens the Card page with the
 * code panel already up. The page reads `?code=1` once and clears it from the address, so Back doesn't reopen it.
 */
export const SHOW_CODE_PATH = '/card?code=1';

/** Does this address ask for the code panel to open? */
export const wantsCode = (search: URLSearchParams): boolean => search.get('code') === '1';

/** The same address with the request taken out (what the page writes back with history.replaceState). */
export function withoutCode(path: string, search: URLSearchParams): string {
  const rest = new URLSearchParams(search);
  rest.delete('code');
  const q = rest.toString();
  return q ? `${path}?${q}` : path;
}
